/**
 * Subdomain Detection Utility
 * Detects which subdomain the user is accessing and provides routing helpers
 */

export const getSubdomain = () => {
  if (typeof window === 'undefined') {
    return 'main'; // Server-side rendering
  }

  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // Handle localhost and IP addresses
  if (hostname === 'localhost' || hostname.startsWith('127.') || hostname.startsWith('192.') || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return 'main'; // Default to main site for local development
  }

  // If we have at least 3 parts (subdomain.domain.tld), extract subdomain
  if (parts.length >= 3) {
    const subdomain = parts[0].toLowerCase();
    
    // Known subdomains
    if (subdomain === 'admin') return 'admin';
    if (subdomain === 'partner') return 'partner';
    if (subdomain === 'api') return 'api';
    
    return subdomain;
  }

  // No subdomain (main domain)
  return 'main';
};

export const isAdminSubdomain = () => {
  return getSubdomain() === 'admin';
};

export const isPartnerSubdomain = () => {
  return getSubdomain() === 'partner';
};

export const isMainSubdomain = () => {
  return getSubdomain() === 'main';
};

export const getDefaultRoute = () => {
  const subdomain = getSubdomain();
  
  switch (subdomain) {
    case 'admin':
      return '/admin/login';
    case 'partner':
      return '/partner/login';
    case 'main':
    default:
      return '/';
  }
};

export const shouldShowRoute = (routePath) => {
  const subdomain = getSubdomain();
  
  // Admin routes should only be accessible from admin subdomain
  if (routePath.startsWith('/admin')) {
    return subdomain === 'admin';
  }
  
  // Partner routes should only be accessible from partner subdomain
  if (routePath.startsWith('/partner')) {
    return subdomain === 'partner';
  }
  
  // Public routes are accessible from all subdomains
  return true;
};
